import React, { FC } from 'react'
import { Button, ButtonType, Heading, Modal, Text } from '@saasalerts/ui'
import { get } from 'lodash'
import { RecommendedActionMap } from '@/types/reports'
import { faArrowRight } from '@awesome.me/kit-e270131d0a/icons/classic/regular'

export const AlertRecommendation: FC<
  React.PropsWithChildren<{
    open: boolean
    setOpen: (open: boolean) => void
    alertDetails?: { eventType: string; productType: string }
    recommendedActions?: RecommendedActionMap
  }>
> = ({ open, setOpen, alertDetails, recommendedActions }) => {
  const Recommendation = () => {
    if (!alertDetails) {
      return <Text>No recommendations</Text>
    }

    const recommendedAction = get(
      recommendedActions,
      alertDetails.eventType,
      undefined
    )

    if (!recommendedAction) {
      return <Text>No recommendations</Text>
    }

    const actionLinks = get(
      recommendedAction.links,
      alertDetails.productType,
      {}
    )

    return (
      <div className="space-y-2">
        <Text>{recommendedAction ? recommendedAction.recAction : ''}</Text>
        <>
          {Object.keys(actionLinks).map((linkName) => {
            return (
              <Button
                kind={ButtonType.SOLID_BLUE_LINK}
                onClick={() =>
                  window.open(get(actionLinks, linkName), '_blank')
                }
                key={linkName}
                iconPosition="right"
                Icon={faArrowRight}
              >
                {linkName}
              </Button>
            )
          })}
        </>
      </div>
    )
  }
  return (
    <Modal open={open} setOpen={setOpen}>
      <Modal.Header>
        <Modal.TitleBar>
          <Heading type="h2">Recommendation</Heading>
        </Modal.TitleBar>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col space-y-2">
          <Recommendation />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          kind={ButtonType.OUTLINE_WHITE}
          onClick={() => {
            setOpen(false)
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
